<!--
Author: TangChen
Date: 2018-11-15
Desc: 投资者知识评测组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-knowledge-test bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/info' }">个人中心</el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <risk-test :data="knowledge" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import riskTest from "@/bizcomponents/acctManager/riskTestDc.vue";
export default {
    name: "KnowledgeTest",
    components: {
        riskTest
    },
    mixins: [mixin],
    data() {
        return {
            knowledge: {
                risk: false,
                url: "invdataup"
            }
        };
    },
    methods: {}
};
</script>
<style lang="scss">
.bizcomp-knowledge-test {
    padding-bottom: 36px;
}
</style>
